import { useQuery } from '@tanstack/react-query';
import { EntityWithIdAndDescription, SectorComercial, UnidadNegocio } from '../../../../../types';
import { HttpCacheOperacion } from '../../../api/httpCacheOperacion';
import { OperacionLEPTitulo, OperacionLEPUnidadNegocio } from "../types/dto";

export const useLEPEmisorTipos = (codSistema: number | undefined | null) => {
  const {
    data: emisorTipos = [],
    isLoading,
    isError,
    error
  } = useQuery<EntityWithIdAndDescription[], Error>({
    queryKey: ['lep-emisor-tipos', codSistema],
    queryFn: () => HttpCacheOperacion.getLEPEmisorTipos(codSistema!),
    enabled: !!codSistema
  })

  return {
    emisorTipos,
    isLoading,
    isError,
    error
  }
}

export const useLEPEmisorLimiteTipos = (codEmisor: number | undefined | null) => {
  const {
    data: emisorLimiteTipos = [],
    isLoading,
    isError,
    error
  } = useQuery<EntityWithIdAndDescription[], Error>({
    queryKey: ['lep-emisor-limite-tipos', codEmisor],
    queryFn: () => HttpCacheOperacion.getLEPEmisorLimiteTipos(codEmisor!),
    enabled: !!codEmisor
  })

  return { emisorLimiteTipos, isLoading, isError, error }
}


export const useLEPTitulos = (codSistema: number | undefined | null, soloInicial = false) => {
  const {
    data: titulos = [],
    isLoading,
    isError,
    error
  } = useQuery<OperacionLEPTitulo[], Error>({
    queryKey: ['lep-titulos', codSistema, soloInicial],

    queryFn: () => {
      if (soloInicial) {
        return HttpCacheOperacion.getLEPTituloInicial(codSistema!);
      }

      return HttpCacheOperacion.getLEPTitulos(codSistema!);
    },

    enabled: !!codSistema
  });

  return {
    titulos,
    isLoading,
    isError,
    error
  };
};


export const useLEPUnidadNegocio = (codPais: number | undefined | null, codSistema: number | undefined | null) => {
  const {
    data: unidadNegocio = [],
    isLoading,
    isError,
    error
  } = useQuery<UnidadNegocio[], Error>({
    queryKey: ['lep-unidad-negocio', codPais, codSistema],
    queryFn: () => HttpCacheOperacion.getUnidadesNegocioPorPaisYSistema(codPais!, codSistema!),
    enabled: !!codPais && !!codSistema
  })

  return {
    unidadNegocio,
    isLoading,
    isError,
    error
  }
}


export const useLEPSectorComercial = (codUnidadNegocio: number | undefined | null, codSistema: number | undefined | null) => {
  const {
    data: sectorComercialTipos = [],
    isLoading,
    isError,
    error
  } = useQuery<SectorComercial[], Error>({
    queryKey: ['LEP-sector-comercial-tipos', codUnidadNegocio, codSistema],
    queryFn: () => HttpCacheOperacion.getSectoresComercialesPorUnidadNegocio(codUnidadNegocio!, codSistema!),
    enabled: !!codUnidadNegocio && !!codSistema
  })

  return {
    sectorComercialTipos,
    isLoading,
    isError,
    error
  }
}
